var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 74,
    viewBox: "0 0 47 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 74V0.5H46.75V74L23.5 61.25L0 74Z",
    fill: "#AD9058"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2983 26.0455H26.9886V37.3807C26.9886 38.6534 26.6847 39.767 26.0767 40.7216C25.4744 41.6761 24.6307 42.4205 23.5455 42.9545C22.4602 43.483 21.196 43.7472 19.7528 43.7472C18.304 43.7472 17.0369 43.483 15.9517 42.9545C14.8665 42.4205 14.0227 41.6761 13.4205 40.7216C12.8182 39.767 12.517 38.6534 12.517 37.3807V26.0455H16.2074V37.0653C16.2074 37.7301 16.3523 38.321 16.642 38.8381C16.9375 39.3551 17.3523 39.7614 17.8864 40.0568C18.4205 40.3523 19.0426 40.5 19.7528 40.5C20.4688 40.5 21.0909 40.3523 21.6193 40.0568C22.1534 39.7614 22.5653 39.3551 22.8551 38.8381C23.1506 38.321 23.2983 37.7301 23.2983 37.0653V26.0455ZM33.7152 26.0455V43.5H30.0249V26.0455H33.7152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/UI.60bc60e681f799f29b6acc07acc9faf0.svg";
export { ForwardRef as ReactComponent };